import { ReactNode } from 'react';
import { Box, theme } from '@bpba/ui-components';

export const LayoutWrapper = ({ children }: { children: ReactNode }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    minHeight="100dvh"
    width="100%"
    style={{ background: theme.colors.secondary[0] }}
  >
    {children}
  </Box>
);
